<template>
  <v-autocomplete
    ref="input"
    v-bind="$attrs"
    :bg-color="backgroundColor"
    clear-icon="mdi-close"
    color="interactive"
    item-color="interactive"
    :item-title="itemTitle"
    :item-value="itemValue"
    :menu-icon="menuIcon"
    :menu-props="menuProps"
    single-line
    :variant="variant"
  >
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData" :key="name">
      <slot v-bind="slotData" :key="name" :name="name" />
    </template>
  </v-autocomplete>
</template>

<script setup lang="ts">
export interface Props {
  backgroundColor?: string
  itemTitle?: string | ((item: any) => any)
  itemValue?: string
  menuIcon?: string
  variant?: 'outlined' | 'plain'
}

withDefaults(defineProps<Props>(), {
  backgroundColor: 'white',
  itemTitle: 'text',
  itemValue: 'id',
  menuIcon: 'mdi-chevron-down',
  variant: 'outlined',
})

const attrs: { 'menu-props'?: object } = useAttrs()
const menuProps = computed(() => ({ contentClass: 'qtm-border', maxHeight: 300, ...attrs['menu-props'] }))

const input = ref<any>(null)
const focus = () => input.value?.focus()

defineExpose({ focus })
</script>
